import Axios from "@app/api/axios";

import { INTEGRATIONS_API_URL } from "@utils/constant";

const removeCredentials = (credentialsId = "") =>
  Axios.delete(`${INTEGRATIONS_API_URL}/credentials/${credentialsId}`);

export default removeCredentials;
